module.exports = __webpack_public_path__ + "static/6-8b5d54cf57c4bb773940b9daf06de356.jpeg";